import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "target"]

  update() {
    const sourceValue = this.sourceTarget.value
    if (sourceValue) {
      this.populateSelect(sourceValue)
    } else {
      this.clearSelect()
    }
  }

  populateSelect(sourceId, targetId = null) {
    fetch(`/${this.data.get('sourceRoutePart')}/${sourceId}/${this.data.get('targetRoutePart')}`, {
      credentials: 'same-origin'
    })
      .then(response => response.json())
      .then(data => {
        const selectBox = this.targetTarget
        selectBox.innerHTML = ''
        data.forEach(item => {
          const opt = document.createElement('option')
          opt.value = item.id
          opt.innerHTML = item[this.data.get('displayAttribute')]
          opt.selected = parseInt(targetId) === item.id
          selectBox.appendChild(opt)
        })
      })
  }

  clearSelect() {
    const selectBox = this.targetTarget
    selectBox.innerHTML = ''
  }
}
